var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FE0420",
    fillRule: "evenodd",
    d: "M4.731 15.653q.885.633 2.273.633q1.677 0 2.68-.758q1.002-.769 1.41-2.318q.245-.95.42-1.957q.057-.36.058-.6q0-.791-.408-1.356a2.43 2.43 0 0 0-1.119-.86q-.711-.294-1.608-.294q-3.297 0-4.09 3.11q-.28 1.143-.431 1.957a4 4 0 0 0-.059.61q0 1.188.874 1.833m4.207-2.511c-.223.866-.838 1.43-1.771 1.43c-.923 0-1.238-.624-1.072-1.43q.21-1.097.42-1.855c.24-.935.806-1.43 1.77-1.43c.92 0 1.22.616 1.061 1.43q-.14.792-.408 1.855m3.531 3.063q.069.08.193.08h1.542a.34.34 0 0 0 .215-.08a.33.33 0 0 0 .125-.21l.487-2.28h1.568c.99 0 1.764-.48 2.331-.907q.862-.64 1.145-1.978q.069-.314.068-.605q0-1.011-.77-1.547q-.76-.535-2.018-.535H14.34a.34.34 0 0 0-.216.082a.34.34 0 0 0-.124.209l-1.565 7.561a.28.28 0 0 0 .034.21m5.51-5.398c-.142.623-.685 1.193-1.323 1.193h-1.303l.449-2.143h1.36c.463 0 .85.092.85.601q0 .15-.034.349",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp);
export default __webpack_public_path__ + "static/media/op.8dea4829250af2541222ec55185144ba.svg";
export { ForwardRef as ReactComponent };